exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".excelButton[data-v-2da02c19]{width:5px;height:5px}", "", {"version":3,"sources":["/opt/build/repo/src/components/configuration/employees-list.vue"],"names":[],"mappings":"AACA,8BACC,UAAW,AACX,UAAY,CACZ","file":"employees-list.vue","sourcesContent":["\n.excelButton[data-v-2da02c19]{\n\twidth: 5px;\n\theight: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2da02c19","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/configuration/employees-list.vue
// module id = 2441
// module chunks = 27